{
  "id": "campaign-069",
  "name": "Untamed Fairway",
  "seed": "campaign:69",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "...,,,,,,,_,",
    "..s,oo,,,,_,",
    "x.sooFo,,,_,",
    ",,swoo,,,,_,",
    ",,,www,,,,_,",
    ",,,,,,,,,,_,",
    ",,W,,,,,,W_,",
    ",,,,b,,b,,_,",
    ",,,,,,,,,,_,",
    ",,h,,..~,h_,",
    ",,,,...~.,_,",
    ",,T,...~.T_,",
    ",,,T....T,_,",
    ",,,,,....._,",
    ",,,,,,,.#._.",
    "..,,,,,,,,,,",
    "S...,,#,,,,,"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 1,
      "y": 2
    },
    {
      "kind": "squirrel",
      "x": 11,
      "y": 14
    },
    {
      "kind": "squirrel",
      "x": 6,
      "y": 9
    },
    {
      "kind": "squirrel",
      "x": 5,
      "y": 13
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 6,
      "y": 14
    },
    {
      "kind": "gas",
      "x": 9,
      "y": 7
    },
    {
      "kind": "gas",
      "x": 3,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 13
    }
  ],
  "moles": {
    "hills": 3,
    "first": 30,
    "every": 20
  },
  "generatorVersion": 3,
  "level": 69,
  "biome": "golf",
  "par": {
    "reel": 16954,
    "push": 10579,
    "selfPropelled": 9660,
    "tractor": 5570,
    "zeroTurn": 6588,
    "fairway": 3814
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 16,
      "selfPropelled": 9,
      "tractor": 17,
      "zeroTurn": 13,
      "fairway": 2
    }
  }
}
